import React, { useEffect, useRef, useState } from "react";
import FanFilterForm from "./FanFilterForm";
import axios from "axios";
import { Button, Card, Menu, Plus, Tabs } from "@opendate-app/setlist";

import { toastError } from "../../../../shared/toastHelper";
import { trackFilterSave } from "./conditionGate";

export const formInputContainerStyle = {
  minWidth: 0,
};

export const formInputStyle = {
  width: "100%",
  height: 40,
  borderRadius: 8,
  padding: "0 10px",
  border: "1px solid var(--sl-border-primary, #ccc)",
  color: "var(--sl-text-primary, #333333)",
};

const cardHeaderStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  flexWrap: "wrap",
  gap: 12,
  padding: "16px 24px",
  color: "var(--sl-text-secondary, #414651)",
  borderBottom: "1px solid var(--sl-border-secondary, #E9EAEB)",
};

const matchRowStyle = {
  display: "flex",
  alignItems: "center",
  flexWrap: "wrap",
  gap: 8,
  fontSize: 14,
  lineHeight: "20px",
};

const conditionCountStyle = {
  fontSize: 12,
  lineHeight: "18px",
  color: "var(--sl-text-quaternary, #717680)",
};

const cardBodyStyle = {
  padding: "16px 24px 8px",
};

const emptyStyle = {
  padding: 24,
  textAlign: "center",
  fontSize: 14,
  lineHeight: "20px",
  color: "var(--sl-text-quaternary, #717680)",
  border: "1px dashed var(--sl-border-primary, #D5D7DA)",
  borderRadius: 10,
};

const cardFooterStyle = {
  display: "flex",
  gap: 8,
  padding: "8px 16px 16px",
};

const groupPanelStyle = {
  border: "1px solid var(--sl-border-secondary, #E9EAEB)",
  background: "var(--sl-bg-secondary, #FAFAFA)",
  borderRadius: 10,
  padding: "12px 16px",
};

const groupHeaderStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 8,
  marginBottom: 8,
  fontSize: 12,
  lineHeight: "18px",
  color: "var(--sl-text-tertiary, #535862)",
};

const groupFooterStyle = {
  display: "flex",
  gap: 4,
  marginTop: 8,
};

const connectorStyle = {
  display: "flex",
  alignItems: "center",
  height: 28,
  paddingLeft: 20,
};

const connectorLineStyle = {
  width: 1,
  height: "100%",
  background: "var(--sl-border-secondary, #E9EAEB)",
};

const connectorPillStyle = {
  marginLeft: -17,
  height: 20,
  padding: "0 8px",
  border: "1px solid var(--sl-border-secondary, #E9EAEB)",
  borderRadius: 9999,
  background: "var(--sl-bg-primary, #fff)",
  color: "var(--sl-text-tertiary, #535862)",
  fontSize: 10,
  lineHeight: "16px",
  fontWeight: 700,
  letterSpacing: "0.04em",
  cursor: "pointer",
};

const MATCH_TABS = [
  { value: "All", label: "All" },
  { value: "At Least One", label: "Any" },
];

const otherMatchCondition = (matchCondition) => (matchCondition === "All" ? "At Least One" : "All");

export const countConditions = (group) => (
  (group.fan_filters || []).length + (group.children || []).reduce((count, child) => count + countConditions(child), 0)
);

const MatchConnector = ({ matchCondition, onToggle }) => (
  <div style={connectorStyle}>
    <span style={connectorLineStyle} />
    <button type="button" style={connectorPillStyle} title="Switch between AND and OR" onClick={onToggle}>
      {matchCondition === "All" ? "AND" : "OR"}
    </button>
  </div>
);

const FanFilterGroupForm = (props) => {
  const {
    csrfToken,
    team,
    refreshParentGroupState,
    onValidChangeCallback,
    onGroupChange,
    depth=0,
  } = props;

  const [fanFilterGroup, setFanFilterGroup] = useState(props.fanFilterGroup);
  const lastReportedRef = useRef(null);

  useEffect(() => {
    if (props.fanFilterGroup === lastReportedRef.current) return;
    setFanFilterGroup(props.fanFilterGroup);
  }, [props.fanFilterGroup]);

  useEffect(() => {
    if (depth === 0 && onGroupChange && fanFilterGroup !== props.fanFilterGroup) {
      lastReportedRef.current = fanFilterGroup;
      onGroupChange(fanFilterGroup);
    }
  }, [fanFilterGroup]);

  const insertFanFilter = (payload) => {
    axios.defaults.headers.common["X-CSRF-TOKEN"] = csrfToken;
    trackFilterSave(axios.post(`/teams/${team.id}/fan_filter_groups/${fanFilterGroup.id}/fan_filters`, {
      fan_filter: {
        ...payload,
        fan_filter_group_id: fanFilterGroup.id,
      }
    })
      .then((data) => {
        setFanFilterGroup({
          ...fanFilterGroup,
          fan_filters: [...fanFilterGroup.fan_filters, data["data"]]
        });
      })
      .catch((error) => {
        const errors = error.response.data;
        toastError(errors.join(", "));
      }));
  };

  const insertFanFilterGroup = (match_condition) => {
    axios.defaults.headers.common["X-CSRF-TOKEN"] = csrfToken;
    trackFilterSave(axios.post(`/teams/${team.id}/fan_filter_groups`, {
      fan_filter_group: {
        parent_id: fanFilterGroup.id,
        match_condition: match_condition
      }
    })
      .then((data) => {
        setFanFilterGroup({
          ...fanFilterGroup,
          children: [...fanFilterGroup.children, data["data"]]
        });
      })
      .catch((error) => {
        const errors = error.response.data;
        toastError(errors.join(", "));
      }));
  };

  const updateFanFilterGroup = (payload) => {
    axios.defaults.headers.common["X-CSRF-TOKEN"] = csrfToken;
    trackFilterSave(axios.put(`/teams/${team.id}/fan_filter_groups/${fanFilterGroup.id}`, { fan_filter_group: payload })
      .then((data) => {
        setFanFilterGroup(data["data"]);
        onValidChangeCallback();
      })
      .catch((error) => {
        const errors = error.response.data;
        toastError(errors.join(", "));
      }));
  };

  const refreshState = () => {
    axios.defaults.headers.common["X-CSRF-TOKEN"] = csrfToken;
    axios.get(`/teams/${team.id}/fan_filter_groups/${fanFilterGroup.id}`)
      .then((data) => {
        setFanFilterGroup(data["data"]);
        onValidChangeCallback();
      })
      .catch((error) => {
        const errors = error.response.data;
        toastError(errors.join(", "));
      });
  };

  const deleteFanFilterGroup = () => {
    axios.defaults.headers.common["X-CSRF-TOKEN"] = csrfToken;
    trackFilterSave(axios.delete(`/teams/${team.id}/fan_filter_groups/${fanFilterGroup.id}`)
      .then(() => {
        refreshParentGroupState();
      })
      .catch((error) => {
        const errors = error.response.data;
        toastError(errors.join(", "));
      }));
  };

  const handleAdd = (value) => {
    value === "Fan Attribute" ? (
      insertFanFilter({
        type: "FanFilters::UserData",
        filter_params: {
          user_data_type: value,
        }
      })
    ) : value === "Purchase History" ? (
      insertFanFilter({
        type: "FanFilters::PurchaseHistory",
      })
    ) : value === "Segment Membership" ? (
      insertFanFilter({
        type: "FanFilters::SegmentMembership",
      })
    ) : value === "Tag" ? (
      insertFanFilter({
        type: "FanFilters::TagData",
        filter_params: {
          tag_data_type: "Tag Name",
        }
      })
    ) : value === "Contact Type" ? (
      insertFanFilter({
        type: "FanFilters::ContactTypeData",
        filter_params: {
          condition: "has any of",
          contact_type_ids: [],
        }
      })
    ) : value === "Email" || value === "Any Email" ? (
      insertFanFilter({
        type: "FanFilters::MessageData",
        filter_params: {
          message_data_type: value,
        }
      })
    ) : value === "Membership" ? (
      insertFanFilter({
        type: "FanFilters::MembershipData",
      })
    ) : value === "Pass" ? (
      insertFanFilter({
        type: "FanFilters::PassData",
      })
    ) : value === "Donation History" ? (
      insertFanFilter({
        type: "FanFilters::DonationHistory",
        filter_params: {
          condition: "Has donated",
          measure: "Total given",
          timeframe: "Ever",
        }
      })
    ) : value === "All" ? (
      insertFanFilterGroup("All")
    ) : value === "At Least One" ? (
      insertFanFilterGroup("At Least One")
    ) : null;
  };

  const conditionMenuItems = [
    ["Fan Attribute", "Purchase History", "Segment Membership"],
    team.package?.series_passes ? ["Membership", "Pass"] : ["Membership"],
    team.can_access_giving_campaigns ? ["Donation History"] : [],
    ["Tag", "Contact Type"],
    ["Email", "Any Email"],
  ]
    .filter((section) => section.length)
    .flatMap((section, i) => [
      ...(i ? [{ divider: true, key: `divider-${i}` }] : []),
      ...section.map((value) => ({ key: value, label: value, onClick: () => handleAdd(value) })),
    ]);

  const toggleMatchCondition = () => updateFanFilterGroup({ match_condition: otherMatchCondition(fanFilterGroup.match_condition) });

  const matchTabs = (
    <Tabs
      aria-label="Match condition"
      variant="button-border"
      size="sm"
      collapseBelow={0}
      items={MATCH_TABS}
      value={fanFilterGroup.match_condition}
      onChange={(value) => updateFanFilterGroup({ match_condition: value })}
    />
  );

  const items = [
    ...fanFilterGroup.fan_filters.map((fanFilter) => (
      <FanFilterForm key={`filter-${fanFilter.id}`}
        csrfToken={csrfToken}
        team={team}
        fanFilter={fanFilter}
        fanFilterGroup={fanFilterGroup}
        refreshParentGroupState={refreshState}
        onValidChangeCallback={onValidChangeCallback}
      />
    )),
    ...fanFilterGroup.children.map((group) => (
      <FanFilterGroupForm key={`group-${group.id}`}
        csrfToken={csrfToken}
        team={team}
        fanFilterGroup={group}
        onValidChangeCallback={onValidChangeCallback}
        refreshParentGroupState={refreshState}
        depth={depth + 1}
      />
    )),
  ].map((item, i) => (
    <React.Fragment key={item.key}>
      {i ? <MatchConnector matchCondition={fanFilterGroup.match_condition} onToggle={toggleMatchCondition} /> : null}
      {item}
    </React.Fragment>
  ));

  const addConditionMenu = (label, variant) => (
    <Menu
      items={conditionMenuItems}
      trigger={<Button variant={variant} size="sm" icon={Plus}>{label}</Button>}
    />
  );

  const addGroupButton = (
    <Button variant="tertiary" size="sm" icon={Plus} onClick={() => insertFanFilterGroup("At Least One")}>
      Add group
    </Button>
  );

  if (depth) {
    return (
      <div style={groupPanelStyle}>
        <div style={groupHeaderStyle}>
          <div style={matchRowStyle}>
            <span style={{ fontWeight: 600, color: "var(--sl-text-secondary, #414651)" }}>Group</span>
            <span>· match</span>
            {matchTabs}
          </div>
          <Button variant="tertiary" size="sm" onClick={deleteFanFilterGroup}>Remove group</Button>
        </div>
        {items}
        <div style={groupFooterStyle}>
          {addConditionMenu("Add to group", "tertiary-color")}
          {addGroupButton}
        </div>
      </div>
    );
  }

  const conditionCount = countConditions(fanFilterGroup);

  return (
    <Card padding="none">
      <div style={cardHeaderStyle}>
        <div style={matchRowStyle}>
          <span>Include fans who match</span>
          {matchTabs}
          <span>of these conditions</span>
        </div>
        <span style={conditionCountStyle}>{conditionCount === 1 ? "1 condition" : `${conditionCount} conditions`}</span>
      </div>
      <div style={cardBodyStyle}>
        {items.length ? items : <div style={emptyStyle}>No conditions yet. Add one below.</div>}
      </div>
      <div style={cardFooterStyle}>
        {addConditionMenu("Add condition", "secondary")}
        {addGroupButton}
      </div>
    </Card>
  );
};

export default FanFilterGroupForm;
